module.exports = __webpack_public_path__ + "img/institutocna.bbe1f895.png";